<template>
  <div>
    <div
      id="slider-label"
      :style="getLabelStyle()"
      :title="label"
    >
      {{ label }}
    </div>
    <v-slider
      v-model="sliderValue"
      :min="min"
      :max="max"
      :hide-details="hideDetails"
      :inverse-label="inverseLabel"
      :thumb-label="thumbLabel"
      :thumb-size="thumbSize"
      :thumb-color="thumbColor"
      :append-icon="appendIcon"
      :disabled="disabledVal"
      :readonly="readonlyVal"
      :track-color="trackColor"
      :color="color"
      @input="onInput"
    >
      <template
        #append
      >
        <image-field
          v-if="appendSrc"
          :src="appendSrc"
          contain
        />
        <v-icon
          v-else
        >
          {{ appendIcon || '' }}
        </v-icon>
      </template>
    </v-slider>
  </div>
</template>

<script>
import ImageField from './ImageField.vue'
import { isObject } from 'lodash'

const DEFAULT_MIN = 0
const DEFAULT_MAX = 100
const DEFAULT_THUMB_LABEL = 'always'
const DEFAULT_THUMB_SIZE = 25
const DEFAULT_THUMB_COLOR = '#6B7280'
const DEFAULT_APPEND_ICON = undefined
const DEFAULT_TRACK_COLOR = '#E5E7EB'
const DEFAULT_COLOR = '#6B7280'
const DEFAULT_INVERSE_LABEL = false
const DEFAULT_HIDE_DETAILS = 'auto'
const DEFAULT_DISABLED_VALUE = false
const DEFAULT_READONLY_VALUE = false
const DEFAULT_LABEL = ''
export default {
  name: 'SliderComponent',

  components: {
    ImageField
  },

  props: {
    value: {
      type: [String, Number],
      default: undefined
    },
    config: {
      type: Object,
      default: () => ({})
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },

  emits: [
    'input',
    'clear-validation-errors',
    'onInput'
  ],

  computed: {
    sliderValue: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },

    min () {
      return this.config?.min || DEFAULT_MIN
    },

    max () {
      return this.config?.max || DEFAULT_MAX
    },

    thumbLabel () {
      return this.config?.thumbLabel || DEFAULT_THUMB_LABEL
    },

    thumbSize () {
      return this.config?.thumbSize || DEFAULT_THUMB_SIZE
    },

    thumbColor () {
      return this.config?.thumbColor || DEFAULT_THUMB_COLOR
    },

    appendIcon () {
      return this.config?.appendIcon || DEFAULT_APPEND_ICON
    },

    trackColor () {
      return this.config?.trackColor || DEFAULT_TRACK_COLOR
    },

    color () {
      return this.config?.color || DEFAULT_COLOR
    },

    inverseLabel () {
      return this.config?.inverseLabel || DEFAULT_INVERSE_LABEL
    },

    hideDetails () {
      return this.config?.hideDetails || DEFAULT_HIDE_DETAILS
    },

    appendSrc () {
      const { src } = this.config || {}
      return src && typeof src === 'string' ? src : (typeof src === 'function' ? src() : undefined)
    },

    disabledVal () {
      return this.config?.disabled || DEFAULT_DISABLED_VALUE
    },

    label () {
      return this.config?.label || DEFAULT_LABEL
    },

    readonlyVal () {
      return this.config?.readonly || this.readonly || DEFAULT_READONLY_VALUE
    }
  },

  methods: {
    onInput (event) {
      this.$emit('clear-validation-errors')
      this.$emit('onInput', {
        event
      })
    },

    getLabelStyle () {
      const { labelStyle } = this.config || {}
      let style = {}

      if (labelStyle && isObject(labelStyle)) {
        style = {
          ...style,
          ...labelStyle
        }
      }

      return style
    }
  }
}
</script>

<style scoped>
#slider-label {
  font-family: 'Satoshi', sans-serif;
  font-size: 14px;
  color: #111827;
  line-height: 20px;
  font-weight: 500;
  /* `display: block` rather than `flex`: `text-overflow` has no effect on a flex
     container's own text, and with a single text node the two lay out the same. */
  display: block;
  margin-bottom: 30px;
  /* Never wrap - see TextField. The full text stays readable through the
     element's `title` on hover. */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
